var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemoryGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32_307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 12.3333V55.6667",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 34H59.6667",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6667 12.3333H16.3333V55.6667H59.6667V12.3333Z",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4743 28.3125H22.1239L26.0294 17.6761H27.359L31.2645 28.3125H29.9142L26.7358 19.3588H26.6527L23.4743 28.3125ZM23.9728 24.1577H29.4157V25.3002H23.9728V24.1577Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9755 28.3125V17.6761H48.694C49.435 17.6761 50.0461 17.8043 50.5274 18.0605C51.0087 18.3132 51.367 18.6542 51.6025 19.0836C51.8379 19.5095 51.9556 19.9821 51.9556 20.5015C51.9556 20.9585 51.8743 21.3359 51.7115 21.6336C51.5523 21.9314 51.341 22.1668 51.0779 22.3399C50.8182 22.513 50.5361 22.6412 50.2314 22.7243V22.8281C50.5568 22.8489 50.884 22.9632 51.213 23.1709C51.5419 23.3787 51.8171 23.6764 52.0387 24.0642C52.2603 24.452 52.3711 24.9263 52.3711 25.4872C52.3711 26.0204 52.25 26.5 52.0076 26.9258C51.7652 27.3517 51.3826 27.6893 50.8598 27.9386C50.3369 28.1879 49.6566 28.3125 48.8187 28.3125H44.9755ZM46.2635 27.17H48.8187C49.6601 27.17 50.2573 27.0072 50.6105 26.6817C50.9671 26.3528 51.1454 25.9546 51.1454 25.4872C51.1454 25.1271 51.0537 24.7948 50.8702 24.4901C50.6866 24.1819 50.4252 23.9361 50.0859 23.7526C49.7466 23.5656 49.345 23.4721 48.881 23.4721H46.2635V27.17ZM46.2635 22.3503H48.6525C49.0403 22.3503 49.39 22.2742 49.7016 22.1218C50.0167 21.9695 50.266 21.7548 50.4495 21.4778C50.6365 21.2009 50.7299 20.8754 50.7299 20.5015C50.7299 20.034 50.5672 19.6376 50.2418 19.3121C49.9163 18.9832 49.4004 18.8187 48.694 18.8187H46.2635V22.3503Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5969 42.125H30.309C30.2327 41.7545 30.0995 41.4291 29.909 41.1486C29.7221 40.8681 29.4935 40.6328 29.2235 40.4423C28.9569 40.2484 28.6609 40.103 28.3354 40.006C28.0099 39.9091 27.6706 39.8606 27.3175 39.8606C26.6735 39.8606 26.09 40.0234 25.5673 40.3488C25.0479 40.6743 24.6341 41.1538 24.326 41.7874C24.0213 42.421 23.869 43.1983 23.869 44.1193C23.869 45.0403 24.0213 45.8176 24.326 46.4512C24.6341 47.0848 25.0479 47.5644 25.5673 47.8898C26.09 48.2153 26.6735 48.378 27.3175 48.378C27.6706 48.378 28.0099 48.3296 28.3354 48.2326C28.6609 48.1356 28.9569 47.992 29.2235 47.8015C29.4935 47.6077 29.7221 47.3705 29.909 47.09C30.0995 46.8061 30.2327 46.4806 30.309 46.1136H31.5969C31.5 46.6572 31.3234 47.1436 31.0672 47.5731C30.811 48.0024 30.4924 48.3676 30.1116 48.6689C29.7307 48.9667 29.3032 49.1934 28.8288 49.3492C28.3579 49.505 27.8541 49.5829 27.3175 49.5829C26.4103 49.5829 25.6036 49.3613 24.8973 48.9181C24.191 48.4749 23.6352 47.8448 23.2301 47.0277C22.8251 46.2106 22.6225 45.2411 22.6225 44.1193C22.6225 42.9975 22.8251 42.0281 23.2301 41.2109C23.6352 40.3938 24.191 39.7637 24.8973 39.3205C25.6036 38.8773 26.4103 38.6557 27.3175 38.6557C27.8541 38.6557 28.3579 38.7336 28.8288 38.8895C29.3032 39.0452 29.7307 39.2738 30.1116 39.575C30.4924 39.8727 30.811 40.2363 31.0672 40.6656C31.3234 41.0915 31.5 41.5779 31.5969 42.125Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2578 49.4375H44.9755V38.8011H48.4033C49.435 38.8011 50.3179 39.0141 51.0519 39.4399C51.7859 39.8624 52.3486 40.47 52.7398 41.2629C53.1311 42.0523 53.3267 42.9975 53.3267 44.0986C53.3267 45.2065 53.1293 46.1604 52.7346 46.9602C52.3399 47.7565 51.7652 48.3694 51.0104 48.7987C50.2556 49.2245 49.338 49.4375 48.2578 49.4375ZM46.2635 48.295H48.1747C49.0541 48.295 49.783 48.1252 50.3612 47.7859C50.9394 47.4466 51.3705 46.9637 51.6544 46.3369C51.9383 45.7102 52.0802 44.9641 52.0802 44.0986C52.0802 43.2399 51.9401 42.5007 51.6596 41.8809C51.3791 41.2577 50.9602 40.7799 50.4027 40.4475C49.8453 40.1116 49.1511 39.9437 48.3201 39.9437H46.2635V48.295Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32_307",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32_307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32_307",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoryGrid);
export default __webpack_public_path__ + "static/media/memory-grid.9db4ccbd27c21a9f311e227c26bd114c.svg";
export { ForwardRef as ReactComponent };